exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-50f26438] .dropdown-menu{min-width:20em!important}[data-v-50f26438] .b-dropdown-text{font-weight:700;font-size:14px;padding-left:.5em}[data-v-50f26438] .btn.dropdown-toggle{color:rgba(77,124,254,.9)!important;height:100%}", ""]);

// exports
